import { ADMIN_TABS } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = { currentTab: 0, disabled: false };

function tabs(state = initialState, action) {
    switch (action.type) {
        case ADMIN_TABS.SET:
            return { ...state, currentTab: action.tab };
        case ADMIN_TABS.DISABLE:
            return { ...state, disabled: true };
        case ADMIN_TABS.ENABLE:
            return { ...state, disabled: false };
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default tabs;
